export enum ValueTypeEnum {
  Currency = 'currency',
  Percentage = 'percentage',
  Text = 'text',
}
